import { render, staticRenderFns } from "./AddBankHolidays.vue?vue&type=template&id=c263b9a0&scoped=true"
import script from "./AddBankHolidays.vue?vue&type=script&lang=js"
export * from "./AddBankHolidays.vue?vue&type=script&lang=js"
import style0 from "./AddBankHolidays.vue?vue&type=style&index=0&id=c263b9a0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c263b9a0",
  null
  
)

export default component.exports